/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiDescriptionList, EuiText } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { OrganizationRoleAssignment } from '@modules/cloud-api/v1/types'
import {
  ApiAccessSelectorTitle,
  getCloudAPIAccessLabel,
} from '@modules/role-assignments-lib/messages'
import { getOrganizationOwnerApiAccessValue } from '@modules/role-assignments-lib'

interface OrganizationOwnerApiAccessProps {
  isApiKey: boolean
  orgRoleAssignment: OrganizationRoleAssignment
}

export const OrganizationOwnerApiAccess: React.FC<OrganizationOwnerApiAccessProps> = ({
  isApiKey,
  orgRoleAssignment,
}) => {
  const getDescriptionListItems = () => {
    const apiAccessValue = getOrganizationOwnerApiAccessValue(orgRoleAssignment, isApiKey)

    const title = <ApiAccessSelectorTitle isApiKey={isApiKey} isOrgOwner={true} />

    const description = (
      <EuiText size='s' color='subdued'>
        <FormattedMessage {...getCloudAPIAccessLabel({ apiAccess: apiAccessValue, isApiKey })} />
      </EuiText>
    )
    return [
      {
        title,
        description,
      },
    ]
  }

  return (
    <EuiDescriptionList compressed={true} type='column' listItems={getDescriptionListItems()} />
  )
}
